import { Status } from '../redux/lounges/types';

export function shouldShowFeedLoadError(status: string, hasFetchedPosts: boolean) {
  return status === Status.ERROR && !hasFetchedPosts;
}

export function shouldShowFeedInitialLoading(
  status: string,
  hasLocalPosts: boolean,
  isFetching: boolean
) {
  return !hasLocalPosts && (status === Status.LOADING || isFetching);
}

export function isFulfilledFeedAction(res: { meta?: { requestStatus?: string } } | null | undefined) {
  return res?.meta?.requestStatus === 'fulfilled';
}
